import {SvgFiltersIdsType} from '@/constants';

import s from './SvgFilters.module.css';

export function SvgFilters(): JSX.Element {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" className={s.root}>
      <defs>
        {/* FilterBatteryEnergyFlashIcon */}
        <filter
          id={SvgFiltersIdsType.FilterBatteryEnergyFlashIcon}
          x="0.0593739"
          y="0.366747"
          width="49.0938"
          height="57.2668"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.65" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.32549 0 0 0 0 0.937255 0 0 0 0 0.113725 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7131_19761" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7131_19761" result="shape" />
        </filter>

        {/* FilterBatteryEnergyIcon */}
        <filter
          id={SvgFiltersIdsType.FilterBatteryEnergyIcon}
          x="0"
          y="0"
          width="22"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.285833 0 0 0 0 0.933333 0 0 0 0 0.0583333 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7202_3120" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7202_3120" result="shape" />
        </filter>

        {/* FilterCheckboxActiveIcon */}
        <filter
          id={SvgFiltersIdsType.FilterCheckboxActiveIcon}
          x="-1"
          y="-1"
          width="22"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.866667 0 0 0 0 0.176471 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7587_1129" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7587_1129" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.615214 0 0 0 0 0.126432 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7587_1129" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.9 0 0 0 0 0 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect2_innerShadow_7587_1129" result="effect3_innerShadow_7587_1129" />
        </filter>

        {/* FilterCheckboxDoneIcon */}
        <filter
          id={SvgFiltersIdsType.FilterCheckboxDoneIcon}
          x="3"
          y="3"
          width="14"
          height="14"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.501318 0 0 0 0 0.501318 0 0 0 0 0.501318 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_7587_15235" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.743311 0 0 0 0 0.743311 0 0 0 0 0.743311 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect1_innerShadow_7587_15235" result="effect2_innerShadow_7587_15235" />
        </filter>

        {/* FilterEnergyModalCloseIcon */}
        <filter
          id={SvgFiltersIdsType.FilterEnergyModalCloseIcon}
          x="1.5"
          y="1.5"
          width="37"
          height="37"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7204_19837" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7204_19837" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7204_19837" />
        </filter>

        {/* FilterFaqIcon */}
        <filter
          id={SvgFiltersIdsType.FilterFaqIcon}
          x="-5"
          y="-2"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745098 0 0 0 0 0.329412 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7503_1641" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7503_1641" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7503_1641" />
        </filter>

        {/* FilterGiftsIcon */}
        <filter
          id={SvgFiltersIdsType.FilterGiftsIcon}
          x="0"
          y="0"
          width="46"
          height="45"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7060_19341" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7060_19341" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7060_19341" />
        </filter>

        {/* FilterImprovementsIcon */}
        <filter
          id={SvgFiltersIdsType.FilterImprovementsIcon}
          x="0"
          y="0"
          width="48"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7060_14918" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7060_14918" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7060_14918" />
        </filter>

        {/* FilterNoticeIcon */}
        <filter
          id={SvgFiltersIdsType.FilterNoticeIcon}
          x="2"
          y="-3"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.866667 0 0 0 0 0.176471 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11444_224784" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11444_224784" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_11444_224784" />
        </filter>

        {/* FilterSettingsIcon */}
        <filter
          id={SvgFiltersIdsType.FilterSettingsIcon}
          x="0.473755"
          y="0.464111"
          width="43.0526"
          height="45.0718"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7060_19352" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7060_19352" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7060_19352" />
        </filter>

        {/* FilterTasksIcon */}
        <filter
          id={SvgFiltersIdsType.FilterTasksIcon}
          x="0"
          y="0"
          width="44"
          height="47"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7060_14931" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7060_14931" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_7060_14931" />
        </filter>

        {/* FilterProjectLogoIcon */}
        <filter
          id={SvgFiltersIdsType.FilterProjectLogoIcon}
          x="41.2647"
          y="0.477551"
          width="336.449"
          height="134.365"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="11.2612" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.866667 0 0 0 0 0.176471 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9452_16535" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9452_16535" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.69218" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.866667 0 0 0 0 0.176471 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_9452_16535" />
        </filter>

        {/* FilterInfoIcon */}
        <filter
          id={SvgFiltersIdsType.FilterInfoIcon}
          x="-0.000488281"
          y="0.5"
          width="31.001"
          height="40.7285"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10272_48214" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10272_48214" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_10272_48214" />
        </filter>

        {/* FilterUpgradeResultIcon */}
        <filter
          id={SvgFiltersIdsType.FilterUpgradeResultIcon}
          x="0.335938"
          y="0.333008"
          width="47.3359"
          height="47.333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13943_180256" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13943_180256" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_13943_180256" />
        </filter>

        {/* RadialGradientImprovementLockIcon */}
        <radialGradient
          id={SvgFiltersIdsType.RadialGradientImprovementLockIcon}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 12) rotate(90) scale(7)"
        >
          <stop stopColor="#FFF171" />
          <stop offset="0.315" stopColor="#FFF171" />
          <stop offset="0.87" stopColor="#FFF171" stopOpacity="0.3" />
        </radialGradient>

        {/* RadialGradientImprovementUnlockIcon */}
        <radialGradient
          id={SvgFiltersIdsType.RadialGradientImprovementUnlockIcon}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 20) rotate(90) scale(12)"
        >
          <stop stopColor="white" />
          <stop offset="0.315" stopColor="white" />
          <stop offset="0.87" stopColor="white" stopOpacity="0.3" />
        </radialGradient>

        {/* RadialGradientEnergyModalCloseIcon */}
        <radialGradient
          id={SvgFiltersIdsType.RadialGradientEnergyModalCloseIcon}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 20) rotate(90) scale(20)"
        >
          <stop />
          <stop offset="1" stopColor="white" />
        </radialGradient>

        {/* ClipPathCheckboxActiveIcon */}
        <clipPath id={SvgFiltersIdsType.ClipPathCheckboxActiveIcon}>
          <path
            d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z"
            fill="white"
          />
        </clipPath>

        {/* ClipPathCheckboxDoneIcon */}
        <clipPath id={SvgFiltersIdsType.ClipPathCheckboxDoneIcon}>
          <path
            d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z"
            fill="white"
          />
        </clipPath>

        {/* ClipPathMultiTapIcon */}
        <clipPath id={SvgFiltersIdsType.ClipPathMultiTapIcon}>
          <rect width="24" height="24" fill="white" />
        </clipPath>

        {/* LinearGradientCheckboxActiveIcon */}
        <linearGradient
          id={SvgFiltersIdsType.LinearGradientCheckboxActiveIcon}
          x1="10"
          y1="3"
          x2="10"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF922D" />
          <stop offset="1" stopColor="#FFE55E" />
        </linearGradient>
      </defs>

      {/* SearchIcon */}
      <defs>
        <filter
          id={SvgFiltersIdsType.SearchIconFilter}
          x="0.0976562"
          y="0.0976562"
          width="58.9023"
          height="57.5957"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.745782 0 0 0 0 0.331006 0 0 0 0 1 0 0 0 0.6 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10014_26001" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10014_26001" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_10014_26001" />
        </filter>
      </defs>
    </svg>
  );
}
